import { PacienteBusca } from '../interfaces/dados-pagamento';
import { SituacaoVc } from '../interfaces/adesao.dto';

export type AcaoVendaCartao = 'adesao' | 'upsell' | 'atraso' | 'indisponivel';

export function normalizarCpf(v: string): string | null {
  const digitos = (v ?? '').replace(/\D/g, '');
  return digitos.length === 11 ? digitos : null;
}

export function mascararCpf(cpf: string): string {
  const d = (cpf ?? '').replace(/\D/g, '');
  return `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**`;
}

// A busca de paciente é por termo livre: aqui só vale o CPF idêntico.
export function pacienteDoCpf(lista: PacienteBusca[], cpf: string): PacienteBusca | null {
  return lista.find(p => (p.nrCpf ?? '').replace(/\D/g, '') === cpf) ?? null;
}

export function acaoDaSituacao(s: SituacaoVc): AcaoVendaCartao {
  switch (s) {
    case 'nao-cliente': return 'adesao';
    case 'cliente': return 'upsell';
    case 'em-atraso': return 'atraso';
    default: return 'indisponivel';
  }
}
